export default __webpack_public_path__ + "static/media/linkedin-icon.7681af3a.svg";